/**
 * Social-link validation for Link-in-Bio.
 *
 * Lifted out of LinkInBio.tsx unchanged so the first-run wizard can share it
 * without importing its parent (which would be a cycle). Mirrors mobile's
 * store/zap/link-in-bio/validation.ts, which must stay in step with it.
 */

// Accepted host(s) per predefined platform — used to catch e.g. a YouTube link
// saved under the Instagram platform. Platforms without a fixed domain
// (Email, Website) or custom/"Other" platforms are left unvalidated.
export const PLATFORM_DOMAINS: Record<string, string[]> = {
    Instagram: ['instagram.com', 'instagr.am'],
    YouTube: ['youtube.com', 'youtu.be'],
    Facebook: ['facebook.com', 'fb.com', 'fb.watch'],
    X: ['x.com', 'twitter.com'],
    LinkedIn: ['linkedin.com'],
    TikTok: ['tiktok.com'],
    WhatsApp: ['wa.me', 'whatsapp.com'],
    Telegram: ['t.me', 'telegram.me', 'telegram.org'],
    Pinterest: ['pinterest.com', 'pin.it'],
    Snapchat: ['snapchat.com'],
    Reddit: ['reddit.com', 'redd.it'],
    Threads: ['threads.net'],
    Spotify: ['spotify.com'],
    Shopify: ['myshopify.com'],
    GitHub: ['github.com'],
    Discord: ['discord.com', 'discord.gg'],
    Patreon: ['patreon.com'],
};
// Empty string = no error. Only checked for platforms with a known fixed domain.
export const socialUrlError = (platform: string, url: string, canonPlatform?: string): string => {
    if (!url?.trim()) return '';
    const domains = PLATFORM_DOMAINS[canonPlatform || platform];
    if (!domains) return '';
    let hostname = '';
    try {
        const withScheme = /^https?:\/\//i.test(url.trim()) ? url.trim() : `https://${url.trim()}`;
        hostname = new URL(withScheme).hostname.toLowerCase().replace(/^www\./, '');
    } catch { return 'Enter a valid URL'; }
    const ok = domains.some((d) => hostname === d || hostname.endsWith(`.${d}`));
    return ok ? '' : `This doesn't look like a ${canonPlatform || platform} link`;
};
